export default __webpack_public_path__ + "checkmark-circle.c1ae096b590182c9.svg";